





























































import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { isEmpty, isNull } from 'lodash'
import { CommissionRecordsService, ScheduleTimeDto } from '../../api'
import { IDateService } from '@master/services/IDateService'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'

@Component
export default class Scheduler extends Vue {
  @inject()
  private $api: API

  @inject()
  protected dateService: IDateService

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  private scheduleEnable: boolean = null
  private scheduleTime: string = null
  private scheduleFrequency: ScheduleTimeDto.frequency = null
  private nextJob: number = null
  private nextJobPeriodCoverage = null
  private adhocBatch: string = null
  private adhocFrom: number = null
  private adhocTo: number = null
  private adHocStatementRef = ''
  private disableAdHocButton = false

  get nextJobTime () {
    if (this.nextJob === null || !this.scheduleEnable) {
      return null
    }

    return this.dateService.format(this.nextJob, 'hh:mm A')
  }

  get nextJobDate () {
    if (this.nextJob === null || !this.scheduleEnable) {
      return null
    }

    return this.dateService.format(this.nextJob, 'DD/MM/YYYY')
  }

  get frequencyOptions () {
    return [
      {
        label: 'Weekly',
        value: 0
      },
      {
        label: 'Bi-Weekly',
        value: 1
      },
      {
        label: 'Monthly',
        value: 2
      }
    ]
  }

  async setScheduleJob () {
    if (isNull(this.scheduleEnable) || isEmpty(this.scheduleTime) || isNull(this.scheduleFrequency)) {
      this.uiService.alert.show({
        type: 'error',
        message: 'Please fill in all input'
      })
      return
    }

    const hour = parseInt(this.scheduleTime.split(':')[0])
    const minute = parseInt(this.scheduleTime.split(':')[1])

    try {
      await CommissionRecordsService.setScheduleJobTime({ enable: this.scheduleEnable, hour, minute, frequency: this.scheduleFrequency, name: ScheduleTimeDto.name.COMMISSION_REPORT })
      await this.fetchConfig()
      this.uiService.alert.show({
        type: 'success',
        message: 'Schedule job config has been changed!'
      })
    } catch (error) {
      this.uiService.alert.show({
        type: 'error',
        message: 'Error occurs! Please try again later.'
      })
      console.error(error)
    }
  }

  async generateAdHocStatement () {
    if (isEmpty(this.adhocBatch) || isEmpty(this.adhocFrom) || isEmpty(this.adhocTo) || isEmpty(this.adHocStatementRef)) {
      this.uiService.alert.show({
        type: 'error',
        message: 'Please fill in all input for Ad Hoc statement'
      })
      return
    }

    const fromDate = new Date(this.adhocFrom)
    const toDate = new Date(this.adhocTo)
    const from = fromDate.getTime() + (fromDate.getTimezoneOffset() * 60000)
    const to = toDate.getTime() + (toDate.getTimezoneOffset() * 60000)
    // const periodCovered = to - from
    this.disableAdHocButton = true
    try {
      if (confirm('This would take some time, it is better to execute this during midnight. Do you still want to proceed?')) {
        await CommissionRecordsService.generateAdHocStatement({ batch: this.adhocBatch, from, to, statementRef: this.adHocStatementRef })
        this.uiService.alert.show({
          type: 'success',
          message: 'Ad-Hoc statement has been started, it would take some time to complete!'
        })
      }
    } catch (error) {
      this.uiService.alert.show({
        type: 'error',
        message: 'Error occurs! Please try again later.'
      })
      console.error(error)
    }
    this.disableAdHocButton = false
  }

  async fetchConfig () {
    const config = await this.$api.commissionRecordsRel.getScheduleTime()

    if (config) {
      const { enable, minute, hour, frequency, next, periodCovered } = config
      this.scheduleFrequency = frequency
      this.scheduleEnable = enable
      this.scheduleTime = `${`0${hour}`.slice(-2)}:${`0${minute}`.slice(-2)}`
      this.nextJob = next
      this.nextJobPeriodCoverage = periodCovered
    }
  }

  async mounted () {
    await this.fetchConfig()
  }

  created () {
    this.uiService = this.sharedVariable.uiService
  }
}
